import {css} from "@emotion/react";
import {Checkbox, styled} from "@reside/ui";

import type {
  NotApplicableStatusOption,
  TaskCheckboxChildren,
  TaskCheckboxFieldProps,
} from "./types";
import {TOOLTIP_LENGTH_DEFAULT} from "./consts";
import {
  CheckboxWrapper,
  ClickOutsideWrapper,
  Label,
  LabelText,
  StyledDatePicker,
} from "./styles";

const defaultChildren = ({
  Checkbox,
  Label,
  FormattedDate,
}: TaskCheckboxChildren) => (
  <>
    <Checkbox />
    <Label />
    <FormattedDate />
  </>
);

const defaultRenderNotApplicableStatusOption = ({
  icon,
  onClick,
  active,
  StyledDropdownSelectOption,
}: NotApplicableStatusOption) => (
  <StyledDropdownSelectOption active={active} onClick={onClick}>
    {icon}
    Not Applicable
  </StyledDropdownSelectOption>
);

export const defaultTaskCheckboxFieldProps = {
  tooltipLength: TOOLTIP_LENGTH_DEFAULT,
  Checkbox,
  CheckboxWrapper,
  ClickOutsideWrapper,
  Label,
  LabelText,
  DatePicker: StyledDatePicker,
  children: defaultChildren,
  renderNotApplicableStatusOption: defaultRenderNotApplicableStatusOption,
} as const;

export const taskCheckboxSmallOverrides: Partial<TaskCheckboxFieldProps> = {
  size: "small",
  Checkbox: styled(defaultTaskCheckboxFieldProps.Checkbox)`
    border-width: 1px;
  `,
  CheckboxWrapper: styled(defaultTaskCheckboxFieldProps.CheckboxWrapper)`
    margin-bottom: 0;

    div {
      margin-bottom: 0;
    }
  `,
  Label: styled(defaultTaskCheckboxFieldProps.Label)`
    line-height: 1;
  `,
  LabelText: styled(defaultTaskCheckboxFieldProps.LabelText)`
    font-size: 1em;
  `,
};

export const taskCheckboxFadedSmallOverrides: Partial<TaskCheckboxFieldProps> =
  {
    size: "small",
    Checkbox: styled(defaultTaskCheckboxFieldProps.Checkbox)<{
      checked?: boolean;
      disabled?: boolean;
    }>`
      border-width: 1px;
      width: var(--task-checkbox-box-px, 14px);
      height: var(--task-checkbox-box-px, 14px);
      min-width: var(--task-checkbox-box-px, 14px);
      min-height: var(--task-checkbox-box-px, 14px);

      ${({checked, disabled, theme}) =>
        !checked &&
        !disabled &&
        css`
          border-color: ${theme.color.darkBlue100};
          background: ${theme.color.white};
        `}
    `,
    CheckboxWrapper: styled(defaultTaskCheckboxFieldProps.CheckboxWrapper)<{
      checked?: boolean;
      disabled?: boolean;
    }>`
      margin-bottom: 0;

      div {
        margin-bottom: 0;
      }

      ${({checked, disabled, theme}) =>
        (checked || disabled) &&
        css`
          color: ${theme.color.gray100};
        `}
    `,
    Label: styled(defaultTaskCheckboxFieldProps.Label)`
      line-height: 1;
    `,
    LabelText: styled(defaultTaskCheckboxFieldProps.LabelText)`
      padding: 0 5px;
      font-size: 1em;
    `,
  };
